module.exports = __webpack_public_path__ + "static/media/tools.d3d71d72.png";